import angular from 'angular';

import EmailIngestTokenService from './email-ingest-token.service';

export default angular
    .module('application.service.email-ingest-token', [])
    .service('emailIngestTokenService', EmailIngestTokenService);



// WEBPACK FOOTER //
// ./src/application/service/email-ingest-token/index.js